import { useEffect, useMemo } from 'react';
import { Table } from 'antd';
import { observer } from 'mobx-react-lite';

import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { CombinedKeyMap } from 'app/libs/combined-key-map/combined-key-map';

import { TTariffProfileGrid } from '../../../core/tariff-profile-grid';
import { useChangeCellState } from './changed-cells-provider';
import { createTableGridData } from './create-table-grid-data';
import { EditCellProvider } from './edit-cell-provider';
import { GridCellComponent } from './grid-cell-component';
import { TariffProfileRulesRecord } from './types';

type RecordKeys = {
  terminalTypeId: string;
  tariffTypeId: string;
  zoneId: string;
};

type DiscountRulesGridProps = {
  data: TTariffProfileGrid;
  onChange?: (
    dataMap: CombinedKeyMap<RecordKeys, TariffProfileRulesRecord>,
  ) => void;
};

export const DiscountRulesGrid = observer(
  ({ data, onChange }: DiscountRulesGridProps) => {
    const gridData = useMemo(() => createTableGridData(data), [data]);

    const changeCellState = useChangeCellState();

    const notify = usePageNotify();

    useEffect(() => {
      onChange &&
        onChange(
          // @ts-expect-error ...
          gridData.dataMap,
        );
    }, [gridData.dataMap]);

    const handleTariffChange = (tariff: TariffProfileRulesRecord) => {
      const ids = {
        terminalTypeId: tariff.terminalType.id,
        tariffTypeId: tariff.tariffType.id,
        zoneId: tariff.zone.id,
      } as const;

      gridData?.dataMap.setRecord(ids, tariff);

      changeCellState.setChangeCellRecord(ids);

      if (changeCellState.getSize() > 0) {
        const messageId = 1;
        const hasMessage = notify.hasMessage({ id: messageId });

        if (!hasMessage) {
          notify.addMessage({
            id: messageId,
            type: 'warning',
            message: 'Есть изменения, которые не были отправлены на сервер',
          });
        }
      }

      onChange &&
        onChange(
          // @ts-expect-error ...
          gridData.dataMap,
        );
    };

    return (
      <EditCellProvider
        cellDataMap={gridData.dataMap}
        onChange={handleTariffChange}
      >
        <Table
          columns={gridData.cols}
          components={{
            body: {
              cell: GridCellComponent,
            },
          }}
          dataSource={gridData.rows}
          size="small"
          pagination={false}
          tableLayout="auto"
          bordered
        />
      </EditCellProvider>
    );
  },
);
